import script from "./NeighborPostsFeed.vue?vue&type=script&lang=ts&setup=true"
export * from "./NeighborPostsFeed.vue?vue&type=script&lang=ts&setup=true"

import "./NeighborPostsFeed.vue?vue&type=style&index=0&id=f3a35264&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3a35264"]])

export default __exports__